import { render, staticRenderFns } from "./GoCityHeader.vue?vue&type=template&id=f5c5fe34"
import script from "./GoCityHeader.vue?vue&type=script&lang=ts"
export * from "./GoCityHeader.vue?vue&type=script&lang=ts"
import style0 from "./GoCityHeader.vue?vue&type=style&index=0&id=f5c5fe34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports